import axios from 'axios';
import { API_BASE_URL } from './tvApi';

const ANALYTICS_BASE = `${API_BASE_URL}/api/analytics`;
const ANALYTICS_CONTENT_UPLOAD_URL = `${ANALYTICS_BASE}/content-upload`;

/**
 * Exec analytics endpoints — shipped 2026-05-12.
 * All read-only. Each accepts ?from, ?to (ISO YYYY-MM-DD) + ?projectId.
 * See docs/strategy/analytics-final.html for the UI spec.
 */
const withPeriod = (params = {}) => {
  const q = new URLSearchParams();
  if (params.from) q.set('from', params.from);
  if (params.to)   q.set('to',   params.to);
  if (params.projectId) q.set('projectId', params.projectId);
  if (params.siteSlug)  q.set('siteSlug',  params.siteSlug);
  if (params.groupBy)   q.set('groupBy',   params.groupBy);
  if (params.limit)     q.set('limit',     String(params.limit));
  const qs = q.toString();
  return qs ? `?${qs}` : '';
};

export const getAnalyticsSummary = async (params) => {
  const res = await axios.get(`${ANALYTICS_BASE}/summary${withPeriod(params)}`);
  return res.data;
};

export const getAnalyticsReliability = async (params) => {
  const res = await axios.get(`${ANALYTICS_BASE}/reliability${withPeriod(params)}`);
  return res.data;
};

export const getAnalyticsTruthCheck = async (params) => {
  const res = await axios.get(`${ANALYTICS_BASE}/truth-check${withPeriod(params)}`);
  return res.data;
};

export const getAnalyticsIncidents = async (params) => {
  const res = await axios.get(`${ANALYTICS_BASE}/incidents${withPeriod(params)}`);
  return res.data;
};

export const getAnalyticsLibrary = async (params) => {
  const res = await axios.get(`${ANALYTICS_BASE}/library${withPeriod(params)}`);
  return res.data;
};

export const getAnalyticsAirtime = async (params) => {
  const res = await axios.get(`${ANALYTICS_BASE}/airtime${withPeriod(params)}`);
  return res.data;
};

/**
 * POST /api/analytics/content-upload
 * @param {{
 *   email: string,
 *   projectId: string,
 *   section: string,
 *   contentId: string,
 *   contentType: string,
 *   fileName: string,
 *   title?: string,
 *   fileSize: number,
 *   mimeType: string,
 * }} payload
 */
export const postContentUploadAnalytics = async (payload) => {
  const response = await axios.post(ANALYTICS_CONTENT_UPLOAD_URL, payload);
  return response.data;
};

/**
 * GET /api/analytics/content-upload?projectId=...&page=...&limit=...
 * @param {{ projectId: string, page?: number, limit?: number }} params
 */
export const getContentUploadAnalytics = async ({ projectId, page = 1, limit = 20 }) => {
  if (!projectId) throw new Error('projectId is required');
  const query = new URLSearchParams({
    projectId,
    page: String(page),
    limit: String(limit),
  });
  const response = await axios.get(`${ANALYTICS_CONTENT_UPLOAD_URL}?${query.toString()}`);
  return response.data;
};
